import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-delete-group-confirm',
  templateUrl: './delete-group-confirm.component.html',
  styleUrls: ['./delete-group-confirm.component.scss']
})
export class DeleteGroupConfirmComponent implements OnInit {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(
    private ref: DynamicDialogRef
  ) {
  }

  public ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public deleteGroup(): void {
    this.ref.close(true);
  }

  public close(): void {
    this.ref.close(false);
  }
  //#endregion
}
